//import Account from './../../Resources/script.js'


//import commonfunctions from "./../../Account/Resources/commonfunctions";
import OrderDetailsRequest from "./OrderDetailsRequest.vue";
import Resources from "./../Template/script.js";
export default {
    mixins: [Resources],
    data () {
        return {}
    },
    components: {
        'order-request':OrderDetailsRequest,
    },
     
    methods: {

    },
    created: function(){
       // this.setPage();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Manage/Orders/script.js